/** A readonly empty list with constant identity */
export const EMPTY_LIST: never[] = [];
